// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.m__F0{margin-block-start:20px}.C2mIW{margin-block-start:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `m__F0`,
	"field": `C2mIW`
};
export default ___CSS_LOADER_EXPORT___;
